import {z} from 'zod';

import {MinMaxQuantity} from '@dms/api/shared';

export const TransferOrderItemFormSchema = (minMaxQuantity: MinMaxQuantity) =>
  z.object({
    quantity: z.number().min(minMaxQuantity.minQuantity).max(minMaxQuantity.maxQuantity),
    serialNumber: z.number().nullish(),
  });

export type TransferOrderItemForm = z.infer<ReturnType<typeof TransferOrderItemFormSchema>>;
